import React from 'react';

const RightClickMenu = ({data, id, showSetStart = false}) => {
    return (
        <div className="RightClickMenu">
            {showSetStart && <button className="rcButton" onClick={()=>data.setStart(id)}>Set Start</button>}
            <button className="rcButton"  onClick={()=>data.removeNode(id)} >Remove</button>
        </div>
    );
};

export default RightClickMenu;